<template :key="key">
  <div style="height: 100%">
    <!-- <Topbar v-if="this.$store.state.topbar_actions_visible" @export="fnExport" @rel_club_event="fnRelClubEvent" @import="fnImport" @destroy="fnDestroy"></Topbar> -->
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
      :fileError="fileError"
      @changeFileError="changeFileError"
      :page_name="page"
    ></Topbar>
    <EventTeamsResume
      v-if="on_event_teams"
      :info="info_event_teams"
      :group="group_selected"
    ></EventTeamsResume>
    <EventCampusResume
      v-if="on_event_campus"
      :info="info_event_campus"
      :group="group_selected"
    ></EventCampusResume>
    <CompetitionCategory
      v-if="on_competition"
      :filters="filters"
      @applyFilters="new_filters"
    ></CompetitionCategory>
    <Table
      :schema="schema"
      :data="data"
      @applyFilters="new_filters"
      :loading="loading"
      ref="table"
      @reload="fnReloadPage"
      @destroy="fnDestroy"
      :page_name="page"
      :submenu="submenu"
      @loadData="loadDataPage"
    ></Table>
    <create-sanction-dialog
      :value="showAddSanctionDialog"
      :loading="isCreatingSanction"
      @createSanction="fnAddSanction"
      @input="showAddSanctionDialog = false"
      ref="createSanctionDialog"
    />
  </div>
</template>

<script>
import CreateSanctionDialog from "@/components/ui/CreateSanctionDialog.vue";
import Table from "@/components/ui/Table";
import Topbar from "@/components/ui/Topbar";
import EventTeamsResume from "@/components/ui/EventTeamsResume";
import EventCampusResume from "@/components/ui/EventCampusResume";
import CompetitionCategory from "@/components/ui/CompetitionCategory";
import { Api } from "@/core/api.js";
import i18n from "@/i18n";
const api = new Api();

export default {
  name: "ListView",
  components: {
    Table,
    Topbar,
    EventTeamsResume,
    EventCampusResume,
    CompetitionCategory,
    CreateSanctionDialog
  },
  props: { page: String, action: String, submenu: String },
  data() {
    return {
      on_submenu: false,
      fileError: false,
      on_competition: false,
      loading: true,
      showAddSanctionDialog: false,
      isCreatingSanction: false
    };
  },
  computed: {
    key() {
      return moment().valueOf();
    },
    schema() {
      if (this.on_submenu) {
        var aSubmenus =
          this.$store.getters["navigation/getCurrentPage"].submenus;
        for (var k in aSubmenus) {
          if (
            aSubmenus[k].name == this.on_submenu &&
            typeof aSubmenus[k].columns !== "undefined"
          ) {
            return aSubmenus[k].columns;
          }
        }
      }
      return this.$store.getters["navigation/getCurrentPage"].columns;
    },
    filters() {
      if (this.on_submenu) {
        var aSubmenus =
          this.$store.getters["navigation/getCurrentPage"].submenus;
        for (var k in aSubmenus) {
          if (
            aSubmenus[k].name == this.on_submenu &&
            typeof aSubmenus[k].filters !== "undefined"
          ) {
            return aSubmenus[k].filters;
          }
        }
      }
      // console.log( "--- FILTERS ---" )
      // console.log( this.$store.getters[ 'navigation/getCurrentPage' ].filters )
      return this.$store.getters["navigation/getCurrentPage"].filters;
    },
    data() {
      var page = this.page.replace("event_", "");
      page = page.replace("_", "/");

      var list = this.$store.getters[page + "/getList"]();
      var total = this.$store.getters[page + "/getTotalList"]();
      //   var oList = {};
      //   for (var i in list) {
      //     var row = list[i];
      //     oList[row.id] = row;
      //   }
      // this.$overlay.hide()
      return { data: list, total: total };
    },
    on_event_teams() {
      if (this.page == "event_teams") {
        this.$store.commit("setTopFiltersVisible", true);
        return true;
      } else {
        if (this.on_competition != true) {
          this.$store.commit("setTopFiltersVisible", false);
        }
        this.$store.commit("teams/setCategorySelected", false);
        return false;
      }
    },
    on_event_campus() {
      //   if (this.$store.state.current_page == "participants" ||) {
      //     this.$store.commit("setTopFiltersVisible", true);
      //     return true;
      //   } else {
      //     this.$store.commit("setTopFiltersVisible", false);
      //     this.$store.commit("persons/setCampusSelected", false);
      //     return false;
      //   }
    },
    info_event_teams() {
      var aEvent = { ...this.$store.getters["events/getCurrentEvent"]() };
      var oCategories = { ...aEvent.categories };
      var aCategories = [];
      for (var k in oCategories) {
        var category = oCategories[k];
        aCategories.push(category);
      }
      return aCategories;
    },

    info_event_campus() {
      var aEvent = { ...this.$store.getters["events/getCurrentEvent"]() };
      var oCategories = { ...aEvent.categories };
      var aCategories = [];
      for (var k in oCategories) {
        var category = oCategories[k];
        aCategories.push(category);
      }
      return aCategories;
    },

    group_selected() {
      return this.$store.getters["teams/getCategorySelected"];
    },

    // on_competition() {
    //     if (this.page.match( 'competition' ) != null) {
    //     this.$store.commit("setTopFiltersVisible", true);
    //     return true;
    //   } else {
    //     // this.$store.commit("setTopFiltersVisible", false);
    //     // this.$store.commit("teams/setCategorySelected", false);
    //     return false;
    //   }
    // }
  },
  watch: {
    // call again the method if the route changes
    $route: "destroyElement",
  },
  created() {
    this.loadDataPage();
  },
  beforeRouteLeave(to, from, next) {
    // this.$destroy();

    next();
  },
  methods: {
    destroyElement() {
      this.$forceUpdate();
      this.loadDataPage();
    },
    loadDataPage(options) {
      this.$overlay.loading();
      var page = this.page.replace("event_", "");

      if (
        this.page.match("competition") != null &&
        this.page != "event_competition_matchs"
      ) {
        this.on_competition = false;
        this.$store.commit("setTopFiltersVisible", false);
      } else if (this.page.match("competition") != null) {
        this.on_competition = false;
        this.$store.commit("setTopFiltersVisible", false);
      } else if (this.page.match("team") != null) {
        this.on_competition = false;
        this.$store.commit("setTopFiltersVisible", true);
      } else {
        this.on_competition = false;
        this.$store.commit("setTopFiltersVisible", false);
      }

      // console.log( this.$route.params );
      this.loading = true;
      var oParams = { ...this.$route.params };
      if (this.$store.state.event_selected) {
        oParams.event = this.$store.getters["events/getCurrentEvent"]().id;
      }
      if (oParams.category_id) {
        this.$store.commit("competition/changeCategory", oParams.category_id);
      }

      var self = this;
      this.on_submenu =
        typeof oParams.submenu !== "undefined"
          ? oParams.submenu
          : typeof this.submenu !== "undefined"
          ? this.submenu
          : false;
      if (typeof this.submenu !== "undefined") oParams.submenu = this.submenu;
      page = page.replace("_", "/");

      var filters_values = JSON.parse(
        JSON.stringify(self.$store.getters["navigation/getCurrentFilters"])
      );
      // console.log( filters_values )
      for (var k in filters_values) {
        if (filters_values[k] == "{USER_ID}") {
          filters_values[k] = self.$store.getters["user/getUser"].id;
        }
        if (filters_values[k] == "{COMPETITION_CATEGORY_ID}") {
          filters_values[k] =
            self.$store.getters["competition/getCategorySelected"];
        }
      }
      self.$store.commit(page + "/applyFilters", filters_values);

      if (options) oParams.page_options = options;
      if (page == "volunteers") {
        let params = { page_options: { num_page: -1, num_items: -1 } };
        this.$store.dispatch("events/loadList", params).then(function () {
          self.$store.dispatch(page + "/loadList", oParams).then(function () {
            // self.$overlay.hide()
            self.loading = false;
          });
        });
      } else {
        this.$store.dispatch(page + "/loadList", oParams).then(function () {
          // self.$overlay.hide()
          self.loading = false;
        });
      }
    },
    changeFileError(state) {
      this.fileError = state;
    },
    new_filters(filters) {
      this.loading = true;
      this.$overlay.loading();

      var page = this.page.replace("event_", "");
      // console.log( " --- NEW FILTERS --- ", filters, page );
      // console.log( filters );
      var self = this;

      if (false && page == "persons") {
        filters = {
          event: this.$store.getters.isEventSelected
            ? this.$store.getters["events/getCurrentEvent"]().id
            : false,
          filters: filters,
        };
      }

      setTimeout(function () {
        page = page.replace("_", "/");
        self.$store.commit(page + "/applyFilters", filters);
        self.$store.commit("navigation/setCurrentFilters", {
          page: self.$store.getters.getCurrentPage,
          event: self.$store.getters.isEventSelected,
          filters: filters,
        });
        self.loadDataPage();
        // self.loading = false;
        // setTimeout(function(){self.loading = false;}, 2000);
      }, 300);
      // this.$store.commit( page + '/applyFilters', filters );

      // this.$overlay.hide()
    },
    top_filters(filters) {
      this.$overlay.loading();
      // console.log( " --- NEW FILTERS --- " );
      // console.log( filters );
      this.$store.commit(this.page + "/applyFilters", filters);
      this.loadDataPage();
      // this.$overlay.hide()
    },
    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "import":
          this.fnImport(emit.params);
          break;
        case "export":
          this.fnExport(emit.params);
          break;
        case "applyFilters":
          this.new_filters(emit.params);
          break;
        case "rel_club_event":
          this.fnRelClubEvent(emit.params);
          break;
        case "rel_hotel_event":
          this.fnRelHotelEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
        case "mail_document":
          this.fnSendMailDocument(emit.params);
          break;
        case "generate_playoff":
          this.fnGeneratePlayoff(emit.params);
          break;
        case "teams_send_image_right":
          this.fnSendTeamsImageRight();
          break;
        case "starters":
          this.fnExportStarters();
          break;
        case "add_sanction":
          this.showAddSanctionDialog = true;
          break;
      }
    },
    fnExport(type) {
      this.$overlay.loading();
      switch (type) {
        case "list":
          this.exportList();
          break;
        case "report":
          this.exportReport();
          break;
        case "click":
          this.setVisibleImport();
          break;
        case "insurance":
          this.exportInsurance();
          break;
        case "gestor":
          this.exportGestoria();
          break;
        case "uniforms":
          this.exportUniforms();
          break;
        case "credentials":
          this.exportCredencials();
          break;
        case "campus_rooms":
          this.exportCampusRooms();
          break;
        case "campus_training":
          this.exportCampusTrainings();
          break;
        case "rooming_list":
          this.exportRoomingList();
          break;
        case "calendar":
          this.exportCalendar();
          break;
        case "matches":
          this.exportMatches();
          break;
      }
    },
    fnSendMailDocument(type) {
      switch (type) {
        case "new":
          this.fnSendMailNewDocument();
          break;
      }
    },
    fnSendTeamsImageRight() {
      var self = this;
      var sIDs = this.$refs.table.getIDsVisible();
      var pagination = this.$refs.table.options;
      var current_filters = this.$refs.table.current_filters_values;
      var aColumnsVisibles = this.$refs.table.getColumnsVisible();

      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var params = {};
      if (pagination.itemsPerPage == -1) {
        params.filters = JSON.stringify(current_filters);
      } else {
        params.data = sIDs;
      }

      this.$popup.confirm(
        {
          message: i18n.t("teams.team_list_confirm_send_image_right"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel"),
        },
        function () {
          self.$overlay.loading();
          var path = "teams/sendImageRight";
          self.$store
            .dispatch(path, {
              event_id: event,
              params: params,
            })
            .then(function () {
              self.$overlay.hide();
            });
        },
        function () {}
      );
    },
    fnGeneratePlayoff() {
      let self = this;
      let phase = this.$store.getters["competition/scoreboard/getList"](
        this.$route.params.phase_id
      );
      let event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      let url =
        "competition/event/" +
        event.id +
        "/category/" +
        phase.category_id +
        "/create_playoff";
      this.$overlay.loading();

      return api.post(url, {}).then(function (response) {
        self.$overlay.hide();
        self.$popup.alert({
          message: i18n.t(
            "S'ha generat els playoff de la categoria: <b> " +
              event.categories[phase.category_id].max_age +
              "</b>"
          ),
          btnSuccess: i18n.t("accept"),
        });
      });
    },
    setVisibleImport() {
      this.$refs.Topbar.show_imports = false;
    },
    exportList() {
      // TODO SHOW OVERLAY LOAD
      var self = this;
      this.$overlay.loading();

      var sIDs = this.$refs.table.getIDsVisible();
      var pagination = this.$refs.table.options;
      var current_filters = this.$refs.table.current_filters_values;
      //   console.log("CURRENT_FILTERS", current_filters);
      //   console.log("PAGINATION", pagination);

      var aColumnsVisibles = this.$refs.table.getColumnsVisible();
      var page = this.$store.getters["navigation/getCurrentPage"].url.replace(
        "/",
        ""
      );

      if (
        page == "competition/matchs/:phase_id" ||
        page == "competition/matchs/:category_id/:phase_id"
      ) {
        page = "competition/matchs/" + this.$route.params.phase_id;
      }

      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;
      var path = page + (event ? "/event/" + event : "") + "/export/list";
      var params = { headers: JSON.stringify(aColumnsVisibles) };
      if (pagination.itemsPerPage == -1) {
        params.filters = JSON.stringify(current_filters);
      } else {
        params.data = sIDs;
      }

      if (
        this.$store.getters["navigation/getCurrentPage"].url.includes(
          "person"
        ) &&
        this.$route.params.submenu &&
        !params.data
      ) {
        params.filters = JSON.parse(params.filters);
        params.filters.submenu = this.$route.params.submenu;
        params.filters = JSON.stringify(params.filters);
      }
      var self = this;
      return api.post(path, params).then(function (response) {
        self.$overlay.hide();
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "calendar.xlsx");
        document.body.appendChild(link);

        self.$overlay.hide();
        link.click();
      });
    },
    exportGestoria() {
      // TODO SHOW OVERLAY LOAD
      var sIDs = this.$refs.table.getIDsVisible();
      var pagination = this.$refs.table.options;
      var current_filters = this.$refs.table.current_filters_values;
      var aColumnsVisibles = this.$refs.table.getColumnsVisible();

      var page = this.$store.getters["navigation/getCurrentPage"].url.replace(
        "/",
        ""
      );
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;
      var path = page + (event ? "/event/" + event : "") + "/export_gestoria";

      var params = { headers: JSON.stringify(aColumnsVisibles) };
      if (pagination.itemsPerPage == -1) {
        params.filters = JSON.stringify(current_filters);
      } else {
        params.data = sIDs;
      }

      var self = this;
      return api.post(path, params).then(function (response) {
        self.$overlay.hide();
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "calendar.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
    exportUniforms() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var self = this;
      return api
        .post("team/event/" + event + "/export/uniforms", {})
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportCredencials() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var self = this;
      return api
        .post("team/event/" + event + "/credentials/export", {})
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportCampusRooms() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var self = this;
      return api
        .post("participants/event/" + event + "/export/room", {})
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportCampusTrainings() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var self = this;
      return api
        .post("participants/event/" + event + "/export/training", {})
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportRoomingList() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var sIDs = this.$refs.table.getIDsVisible();
      var pagination = this.$refs.table.options;
      var current_filters = this.$refs.table.current_filters_values;
      var aColumnsVisibles = this.$refs.table.getColumnsVisible();

      var page = this.$store.getters["navigation/getCurrentPage"].url.replace(
        "/",
        ""
      );
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;
      var path =
        page + (event ? "/event/" + event : "") + "/export/rooming_list";

      var params = { headers: JSON.stringify(aColumnsVisibles) };
      if (pagination.itemsPerPage == -1) {
        params.filters = JSON.stringify(current_filters);
      } else {
        params.data = sIDs;
      }
      var self = this;
      return api.post(path, params).then(function (response) {
        self.$overlay.hide();
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "calendar.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
    fnExportStarters() {
      // TODO SHOW OVERLAY LOAD
      var sIDs = this.$refs.table.getIDsVisible();
      var pagination = this.$refs.table.options;
      var current_filters = this.$refs.table.current_filters_values;
      
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;
      var params = { };
      if (pagination.itemsPerPage == -1) {
        params.filters = JSON.stringify(current_filters);
      } else {
        params.data = sIDs;
      }
      var self = this;
      return api
        .post("team/event/" + event + "/starters/teams/" + localStorage.token, params)
        .then(function (response) {
          self.$overlay.hide();
          window.open(response.data.url, "_blank");
        });
    },
    exportCalendar() {
      var self = this;
      return api
        .get("competition/export/match_hotels")
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportMaches() {
      var self = this;
      return api.get("ompetition/export/match").then(function (response) {
        self.$overlay.hide();
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "matches.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
    fnSendMailNewDocument() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;
      var self = this;
      if (this.page == "event_volunteers") {
        return api
          .post("volunteer/event/" + event + "/mail/new_document", {})
          .then(function (response) {
            self.$overlay.hide();
            if (response.status) {
              self.$popup.alert({
                message: i18n.t(
                  "Mail enviat a tots els voluntaris confirmats del esdeveniment"
                ),
                btnSuccess: i18n.t("accept"),
              });
            } else {
              self.$popup.alert({
                message: i18n.t(response.message),
                btnSuccess: i18n.t("accept"),
              });
            }
          });
      } else {
        return api
          .post("participants/event/" + event + "/mail/new_document", {})
          .then(function (response) {
            self.$overlay.hide();
            if (response.status) {
              self.$popup.alert({
                message: i18n.t(
                  "Mail enviat a tots els participants amb accès a la Zona Privada"
                ),
                btnSuccess: i18n.t("accept"),
              });
            } else {
              self.$popup.alert({
                message: i18n.t(response.message),
                btnSuccess: i18n.t("accept"),
              });
            }
          });
      }
    },
    exportInsurance() {
      // TODO SHOW OVERLAY LOAD
      this.$overlay.loading();
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event ? event.id : false;

      var self = this;
      return api
        .post("person/export/insurance/" + event, {})
        .then(function (response) {
          self.$overlay.hide();
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "calendar.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },
    exportReport() {
      return api.get("/report").then(function (response) {
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "calendar.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
    fnRelClubEvent() {
      var self = this;
      this.$card.relClubEvent({
        club_id: this.$route.params.id,
        event_id: this.$store.getters["events/getCurrentEvent"]().id,
        callBack: function (plug, params, store) {
          self.$store
            .dispatch("clubs/addRelClubEvent", {
              club_id: plug.params.club.value,
              event_id: plug.params.event.value,
              user_id: plug.params.user.value,
            })
            .then(function () {
              self.$popup.alert({
                message: i18n.t("teams.create_user_zonaequipos"),
                btnSuccess: i18n.t("accept"),
              });
              self.$card.close();
              self.loadDataPage();
            })
            .catch(function (e) {
              self.$popup.alert({
                message: i18n.t("errors." + e),
                btnSuccess: i18n.t("accept"),
              });
              self.$card.close();
            });
        },
      });
    },
    fnRelHotelEvent() {
      var self = this;
      this.$card.relHotelEvent({
        hotel_id: this.$route.params.id,
        event_id: this.$store.getters["events/getCurrentEvent"]().id,
        callBack: function (plug, params, store) {
          self.$store
            .dispatch("hotels/addRelHotelEvent", {
              hotel_id: plug.params.hotel.value,
              event_id: plug.params.event.value,
            })
            .then(function () {
              self.$popup.alert({
                message: i18n.t("hotels.created_rel_hotel_event"),
                btnSuccess: i18n.t("accept"),
              });
              self.$card.close();
              self.loadDataPage();
            })
            .catch(function (e) {
              self.$popup.alert({
                message: i18n.t("hotels.errors." + e),
                btnSuccess: i18n.t("accept"),
              });
              self.$card.close();
            });
        },
      });
    },
    fnReloadPage() {
      this.loadDataPage();
    },
    fnImport(data) {
      this.$overlay.loading();
      let form = new FormData();
      form.append("file", data.file);
      if (data.type) {
        form.append("type", data.type);
      }
      var self = this;
      this.$store.dispatch("finances/upload", form).then((data) => {
        if (data != false) {
          self.$destroy();
          return self.$router.push({ name: "event_finances_add", params: {} });
        }
        self.fileError = true;
        self.$overlay.hide();
        return true;
      });
    },
    fnDestroy() {
      this.$ref.table.fnDestroy();
      this.$destroy();
    },
    async fnAddSanction (sanctionData) {
      this.isCreatingSanction = true

      try {
        await this.$store.dispatch('competition/sanctions/add_sanction', sanctionData)

        this.showAddSanctionDialog = false
        this.loadDataPage(true)
      } catch (error) {
        console.log('notify', { type: 'error', message: 'Failed to create sanction' })
      } finally {
        this.isCreatingSanction = false
        this.$refs.createSanctionDialog.resetState()
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
